const getters = {
  cname: state => state.app.cname,
  language: state => state.app.language,
}
export default getters
